<template>
  <div class="rules">
    <!-- <h4 class="headtitle">{{$t('Candidates')}}</h4>
    <div class="boxs">
     {{$t('Candidatesbody')}}
    </div>

    <h4 class="headtitle">{{$t('Conditions')}}</h4>
    <div class="boxs">
      {{$t('Conditionsbody')}}
    </div>

    <h4 class="headtitle">{{$t('Costs')}}</h4>
    <div class="boxs">
      {{$t('Costsbody')}}
    </div>

    <h4 class="headtitle">{{$t('Reviewprinciple')}}</h4>
    <div class="boxs">
      {{$t('Reviewprinciplebody')}}
    </div>

    <h4 class="headtitle">{{$t('Reviewprocess')}}</h4>
    <div class="boxs">
      {{$t('Reviewprocessbody')}}
    </div>

    <h4 class="headtitle">{{$t('Entryway')}}</h4>
    <div class="boxs">
      {{$t('Entrywaybody')}}
    </div>

    <h4 class="headtitle">{{$t('Registration')}}</h4>
    <div class="boxs">
     {{$t('Registrationbody')}}
    </div> -->
    <div v-html="content">
      
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      resourceList: [],
     content:''
    };
  },
  created() {
    this.$getHttp("pc/tEntryInformation/findAllEntryInformations").then(
      (res) => {
        if (res.success) {
          // this.resourceList =  res.EntryInformations;
         this.content = res.EntryInformations[0].content

          
        } else {
          this.$message({
            message: res.msg,
          });
        }
      }
    );
  },
};
</script>

<style lang="less">
.rules {
  overflow: hidden;
  text-align: left;
  .headtitle {
    position: relative;
    font-size: 26px;
    font-family: PingFang SC-Regular, PingFang SC;
    color: #333333;
    font-weight: 500;
    padding-left: 20px;
    margin-left: 5px;
    margin-top: 6px;
    margin-bottom: 25px;
    // &:before {
    //   position: absolute;
    //   content: "";
    //   left: 0;
    //   top: 50%;
    //   transform: translateY(-50%);
    //   width: 4px;
    //   height: 24px;
    //   background: #6f73f4;
    //   border-radius: 2px 2px 2px 2px;
    // }
  }
  // .boxs {
  //   font-size: 22px;
  //   font-family: PingFang SC-Regular, PingFang SC;
  //   font-weight: 400;
  //   color: #333333;
  //   line-height: 50px;
  //   margin-bottom: 60px;
  //   white-space: pre-line;
  // }
}
</style>